var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15402_22629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 6.38845C10.4601 6.38845 10.8332 6.76155 10.8332 7.22179V11.1107C10.8332 11.5709 10.4601 11.944 9.9999 11.944C9.53966 11.944 9.16657 11.5709 9.16657 11.1107V7.22179C9.16657 6.76155 9.53966 6.38845 9.9999 6.38845Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 13.8885C11.1111 14.5021 10.6136 14.9996 9.99997 14.9996C9.38632 14.9996 8.88886 14.5021 8.88886 13.8885C8.88886 13.2748 9.38632 12.7773 9.99997 12.7773C10.6136 12.7773 11.1111 13.2748 11.1111 13.8885Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.77734C8.83854 2.77734 8.01792 3.5577 7.60844 4.38481C7.39513 4.81566 6.39979 6.71524 5.38113 8.65905L5.35031 8.71786C4.35875 10.61 3.35234 12.5304 3.11903 13.0017C2.70563 13.837 2.58808 14.9461 3.22167 15.9062C3.85454 16.8652 4.93577 17.2218 5.95948 17.2218L14.0404 17.2218C15.0641 17.2218 16.1453 16.8653 16.7782 15.9062C17.4118 14.9461 17.2943 13.837 16.8809 13.0017C16.6479 12.5311 15.6444 10.6162 14.6544 8.72707L14.6187 8.65903C13.6 6.71512 12.6047 4.81572 12.3916 4.38504C11.9822 3.55781 11.1616 2.77734 10 2.77734ZM9.10207 5.12428C9.55113 4.21725 10.4489 4.21725 10.8978 5.12428C11.1224 5.57803 12.1334 7.50718 13.144 9.4356C14.1536 11.362 15.1628 13.2878 15.3872 13.7411C15.8361 14.6481 15.3872 15.5551 14.0404 15.5551L5.95948 15.5551C4.61275 15.5551 4.16381 14.6481 4.61275 13.7411C4.83747 13.287 5.84961 11.3557 6.86086 9.42601C7.86978 7.5008 8.8778 5.57728 9.10207 5.12428Z",
    fill: "#71869D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15402_22629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProblem);
export default __webpack_public_path__ + "static/media/iconProblem.15d94d789f56e9c54e79653968acd146.svg";
export { ForwardRef as ReactComponent };